import { RelationshipPack, RelationshipCategoryManifest, RelationshipSubtypeManifest } from '../../../lib/diagram/relationship-manifest.types';

export const BpmnFlowsCategory: RelationshipCategoryManifest = {
    id: 'bpmn_flows',
    label: 'BPMN Flows',
    order: 10,
};

export const MessageFlowSubtype: RelationshipSubtypeManifest = {
    id: 'bpmn_message',
    categoryId: 'bpmn_flows',
    label: 'connector.types.bpmnMessageFlow',
    edgeType: 'sequence_flow',
    synonyms: ['message', 'dashed', 'communication'],
    ontology: {
        predicate: 'message_flow',
        status: 'projection_enabled',
        facets: ['dependency'],
    },
    defaultEdgeProps: {
        dashed: true,
        dash: [8, 4],
        startArrow: { type: 'circleOutline', size: 6 },
        endArrow: { type: 'outlineBlock', size: 10 },
        color: '#334155',
    },
};

export const SequenceFlowSubtype: RelationshipSubtypeManifest = {
    id: 'bpmn_sequence',
    categoryId: 'bpmn_flows',
    label: 'connector.types.bpmnSequenceFlow',
    edgeType: 'sequence_flow',
    synonyms: ['sequence', 'standard', 'flow'],
    ontology: {
        predicate: 'sequence_flow',
        status: 'projection_enabled',
        facets: ['dependency'],
    },
    defaultEdgeProps: {
        dashed: false,
        dash: undefined,
        startArrow: { type: 'none', size: 6 },
        endArrow: { type: 'triangle', size: 8 },
        color: '#334155',
    },
};

export const DefaultFlowSubtype: RelationshipSubtypeManifest = {
    id: 'bpmn_default',
    categoryId: 'bpmn_flows',
    label: 'connector.types.bpmnDefaultFlow',
    edgeType: 'sequence_flow',
    synonyms: ['default', 'backslash'],
    ontology: {
        predicate: 'sequence_flow',
        status: 'projection_enabled',
        facets: ['dependency'],
        qualifierKeys: ['default'],
    },
    defaultEdgeProps: {
        dashed: false,
        dash: undefined,
        startArrow: { type: 'backslash', size: 6 },
        endArrow: { type: 'triangle', size: 8 },
        color: '#334155',
    },
};

export const ConditionalFlowSubtype: RelationshipSubtypeManifest = {
    id: 'bpmn_conditional',
    categoryId: 'bpmn_flows',
    label: 'connector.types.bpmnConditionalFlow',
    edgeType: 'sequence_flow',
    synonyms: ['conditional', 'diamond', 'decision'],
    ontology: {
        predicate: 'sequence_flow',
        status: 'projection_enabled',
        facets: ['dependency'],
        qualifierKeys: ['condition'],
    },
    defaultEdgeProps: {
        dashed: false,
        dash: undefined,
        startArrow: { type: 'diamond', size: 8 },
        endArrow: { type: 'triangle', size: 8 },
        color: '#334155',
    },
};

export const DataAssociationSubtype: RelationshipSubtypeManifest = {
    id: 'bpmn_data_association',
    categoryId: 'bpmn_flows',
    label: 'connector.types.bpmnDataAssociation',
    edgeType: 'sequence_flow',
    synonyms: ['data', 'association', 'dotted'],
    ontology: {
        predicate: 'data_flow',
        status: 'projection_enabled',
        facets: ['dependency'],
    },
    defaultEdgeProps: {
        dashed: true,
        dash: [4, 4],
        startArrow: { type: 'none', size: 6 },
        endArrow: { type: 'chevron', size: 7 },
        color: '#475569',
    },
};

export const BpmnRelationshipPack: RelationshipPack = {
    meta: {
        id: 'bpmn-relationships',
        name: 'BPMN Relationships',
        version: '1.0.0',
    },
    diagramType: 'flowchart',
    categories: [BpmnFlowsCategory],
    subtypes: [
        MessageFlowSubtype,
        SequenceFlowSubtype,
        DefaultFlowSubtype,
        ConditionalFlowSubtype,
        DataAssociationSubtype,
    ],
};
